export enum ProjectDurationMetric {
  PausedDays = 'pausedDays',
  ProvidenceDays = 'providenceDays',
  TotalProjectDays = 'totalProjectDays',
}
